<template>
  <div>
    <vx-card  v-can="'view-user'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">First Name</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['first_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Last Name</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['last_name']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Email</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['email']" class="mb-4 md:mb-0 w-full"/>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <!-- CARD 9: DISPATCHED ORDERS -->
      <div class="vx-col w-full">
        <vx-card title="SUPPLIER USERS" v-can:any="['view-user', 'create-user']">
          <template slot="actions">
            <vs-button v-can="'create-user'" @click="onClickCreateUser" class="mr-4" color="primary" type="filled">Create Supplier User</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table v-can="'view-user'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff"  @sort="handleSort"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">FIRST NAME</vs-th>
                <vs-th sort-key="contact_1">LAST NAME</vs-th>
                <vs-th class="float-left">STATUS</vs-th>
                <vs-th width="15%" sort-key="email">EMAIL</vs-th>
                <vs-th width="15%" sort-key="email">USER ROLE</vs-th>
                <vs-th>LAST LOGGED</vs-th>
               <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  @click="onClickSupplierUpdate(data[indextr].id)"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].first_name">
                    {{ data[indextr].first_name }}
                  </vs-td>
                  <vs-td :data="data[indextr].last_name">
                    {{ data[indextr].last_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].is_active">
                    <vs-chip :color="data[indextr].is_active === 1 ? 'primary' : 'danger'">
                      {{ data[indextr].is_active === 1 ? 'Active' : 'De-active' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].role">
                    {{ data[indextr].role ? data[indextr].role.name : '' }}
                  </vs-td>

                  <vs-td :data="data[indextr].last_login_at">
                    {{ __dateTimeFormatter(data[indextr].last_login_at) }}
                  </vs-td>


                 <vs-td>
                   <div class="vx-row">
                    <vx-tooltip text="View/Update User" position="left" class="mr-2" v-can="'edit-user'">
                       <vs-button @click.stop="onClickSupplierUpdate(data[indextr].id)" color="primary" size="small" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                     </vx-tooltip>
                     <vx-tooltip text="Resend Welcome Email" position="left" 
                      v-if="!data[indextr].email_verified_at && data[indextr].is_active === 0">
                       <vs-button @click.stop="onClickResendWelcomeEmail(data[indextr].email)" color="warning" size="small" type="border" icon-pack="feather" icon="icon-inbox"></vs-button>
                     </vx-tooltip>
                   </div>
                 </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-supplier-pop-up ref="createSupplierPopUp"/>
    <update-supplier-pop-up ref="updateSupplierPopUp"/>
    <view-supplier-pop-up ref="viewSupplierPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRepository = RepositoryFactory.get('supplier')
  import CreateSupplierPopUp from '@/components/popups/supplier/CreateSupplierPopUp'
  import UpdateSupplierPopUp from '@/components/popups/supplier/UpdateSupplierPopUp'
  import ViewSupplierPopUp from '@/components/popups/supplier/ViewSupplierPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import { defaultPagination, perPageList } from "@/constants/config";

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateSupplierPopUp,
      UpdateSupplierPopUp,
      ViewSupplierPopUp
    },
    mixins : [Filter, SuccessMessage],
    async mounted () {

      // this.$refs.filterCard.isContentCollapsed = false
      // this.$refs.filterCard.maxHeight = '1.5rem'

      this.$vs.loading()
      this.loadStaff()
      this.$vs.loading.close()

    },
    methods: {
      async refreshData () {
        this.loadStaff()
      },

      async loadStaff() {
        this.$vs.loading()
        try {
          const {data} = await SupplierRepository.get(this.page, this.filterQuery, 20, this.sort)
          this.staff =  data.data
          this.meta = data.meta
        } catch (error) {
          
        }
        this.$vs.loading.close()
      },
      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      async onClickCreateUser () {
        await this.$refs.createSupplierPopUp.openPopup()
      },
      async onClickSupplierUpdate (id) {
        await this.$refs.updateSupplierPopUp.openPopup(id)
      },
      async onClickSupplierView (id) {
        await this.$refs.viewSupplierPopUp.openPopup(id)
      },
      async onClickResendWelcomeEmail(email) {
        console.log(email);
        try {
          await SupplierRepository.resendUserWelcomeEmail(email)
          this.showSuccessMessage('Welcome email resent')
        } catch (error) {
          console.log(error);
        }
      },
      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      }

    },
    watch : {
      page(){
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
